import { get } from '../httpClient';

export const linkPreviewAPI = {
  getLinkPreview: params => get('/api/link-preview', params),
};